import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { FollowUpGql as FollowUpType, FollowUpGqlListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const LIST_QUERY = graphql(`
  query FollowUpStoreList($search: String, $pagination: PaginationInput, $sort: SortInput) {
    followUps(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        locationId
        contactId
        ownerName
        ownerId
        appointmentDate
        followUpDate
        isConnected
        isScheduled
        description
        associatedType
        associatedTypeId
        associatedPeopleIndex
        createdDate
        updatedDate
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query FollowUpStoreGet($id: ID!) {
    followUp(id: $id) {
      id
      orgId
      workspaceId
      locationId
      contactId
      ownerName
      ownerId
      appointmentDate
      followUpDate
      isConnected
      isScheduled
      description
      associatedType
      associatedTypeId
      associatedPeopleIndex
      createdDate
      updatedDate
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation FollowUpStoreCreate($input: CreateFollowUpInput!) {
    createFollowUp(input: $input) {
      id
      orgId
      workspaceId
      locationId
      contactId
      ownerName
      ownerId
      appointmentDate
      followUpDate
      isConnected
      isScheduled
      description
      associatedType
      associatedTypeId
      associatedPeopleIndex
      createdDate
      updatedDate
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation FollowUpStoreUpdate($id: ID!, $input: UpdateFollowUpInput!) {
    updateFollowUp(id: $id, input: $input) {
      id
      orgId
      workspaceId
      locationId
      contactId
      ownerName
      ownerId
      appointmentDate
      followUpDate
      isConnected
      isScheduled
      description
      associatedType
      associatedTypeId
      associatedPeopleIndex
      createdDate
      updatedDate
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteFollowUp($id: ID!) {
    deleteFollowUp(id: $id)
  }
`)

export class FollowUpStore extends EntityStore<
  FollowUpType,
  FollowUpGqlListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `FollowUpGQL`,
      extractList: (data: any) => data.followUps,
      extractOne: (data: any) => data.followUp,
      extractMutated: (data: any) => data.updateFollowUp ?? data.createFollowUp,
    })
  }
}
